import { useDateFormatter } from '@nexelem/utils';
import { useTimelineStore } from '../../Gantt/store';
import { useSimulationBorderMarker } from '../hooks';
import { faSnowflake } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import { Popover } from '@nexelem/components';

type SimulationRangeTimeProps = {
  startDate: Date;
};

export const SimulationRangeTime = ({ startDate }: SimulationRangeTimeProps) => {
  const format = useDateFormatter({ displayWithHours: true });
  const currentFilter = useTimelineStore((state) => state.filters.current);

  const simMarker = useSimulationBorderMarker(startDate, currentFilter.measureScale);

  if (!simMarker.isVisible || !simMarker.toPublishBoundaryDate) {
    return null;
  }

  return (
    <>
      <div className="absolute -top-5 w-9 -translate-x-1/2" style={{ left: simMarker.toPublishBoundaryLeftDistance }}>
        <Popover.Root>
          <Popover.Trigger>
            <div className="mx-1 flex h-7 w-7 cursor-pointer items-center justify-center rounded-full border border-border-status-orange-darker bg-surface-status-orange-darker shadow-tiny">
              <FontAwesomeIcon className="text-text-primary-inverse" icon={faCheck} />
            </div>
          </Popover.Trigger>
          <Popover.Content>{format(simMarker.toPublishBoundaryDate)}</Popover.Content>
        </Popover.Root>
      </div>

      <div className="absolute -top-5 w-9 -translate-x-1/2" style={{ left: simMarker.freezeBoundaryLeftDistance }}>
        <Popover.Root>
          <Popover.Trigger>
            <div className="mx-1 flex h-7 w-7 cursor-pointer items-center justify-center rounded-full border border-border-status-navy-darker bg-surface-status-navy-darker shadow-tiny">
              <FontAwesomeIcon className="text-text-primary-inverse" icon={faSnowflake} />
            </div>
          </Popover.Trigger>
          <Popover.Content>{format(simMarker.freezeBoundaryDate)}</Popover.Content>
        </Popover.Root>
      </div>
    </>
  );
};
